// extracted by mini-css-extract-plugin
export default {"wrap":"Banner_wrap__4KwBZ","head":"Banner_head__v4cKf","title":"Banner_title__okH-s","text":"Banner_text__ILUW7","image":"Banner_image__x7NKi"};